import { styled } from '@mui/material/styles'

export const CenteredText = styled('div')({
  width:"100%",
  textAlign: "center"
});
